import { useContext, useEffect, useState } from "react";

import { AuthAppContext } from "components/root/auth-app-provider";
import { getNavElements } from "consts";
import { useFlags } from "utils";

const HIDE_PROPERTY_CARRIERS = ["vave", "markel"];

export const useNavItems = () => {
  const { policy, userPolicyProperties } = useContext(AuthAppContext);
  const { policyPage: isPolicyPageEnabled } = useFlags();
  const hidePropertyTab =
    policy?.isCommercial ||
    HIDE_PROPERTY_CARRIERS.includes(
      userPolicyProperties?.carrierGroup?.toLowerCase() ?? ""
    );

  const navElements = getNavElements(hidePropertyTab, isPolicyPageEnabled);
  const [navItems, setNavItems] = useState(navElements);

  useEffect(() => {
    setNavItems(getNavElements(hidePropertyTab, isPolicyPageEnabled));
  }, [hidePropertyTab, policy, isPolicyPageEnabled]);

  return navItems;
};
